<template>
    <div>
        <b-form-group
            id="fieldset-usePhonenumber"
            :description="$t('settings.channels.sms.use-phonenumber.description')"
            :label="$t('settings.channels.sms.use-phonenumber.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="usePhone"
        >
            <b-form-checkbox
                v-model="getSettingByName('sms_use_phonenumber', '1').value"
                inline
                name="usePhone"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <validation-provider
            v-if="getSettingByName('sms_use_phonenumber').value === '0'"
            #default="{ errors }"
            :name="$t('settings.channels.sms.sender.label')"
            :rules="smsSenderRules"
        >
            <b-form-group
                id="fieldset-smsSender"
                :description="$t('settings.channels.sms.sender.description')"
                :label="$t('settings.channels.sms.sender.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="smsSender"
            >
                <b-form-input
                    id="smsSender"
                    v-model="getSettingByName('sms_sender', '').value"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>

        <b-form-group
            v-if="channelData.provider === ProviderType.SPRYNG"
            id="fieldset-sms-credits"
            :label="$t('settings.channels.sms.balance')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="identity"
        >
            <b-spinner v-if="isFetchingCredits" small></b-spinner>{{ $tc("settings.channels.sms.credits", credits) }}
        </b-form-group>
    </div>
</template>

<script>
import useChannelSettings from "../useChannelSettings";
import { ValidationProvider } from "vee-validate";
import { BContainer, BFormGroup, BFormInput, BFormCheckbox, BFormFile, BSpinner } from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import axios from "axios";
import { ProviderType } from "@/types/provider.type"; // NOTE: importing from plain axios because we need to make a request to an external API and need custom auth for that

export default {
    components: {
        BContainer,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BFormFile,
        BSpinner,
        ValidationProvider,
    },
    props: {
        channelData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { getSettingByName } = useChannelSettings(props.channelData);
        const isFetchingCredits = ref(false);
        const credits = ref(0);

        const smsSenderRules = {
            required: true,
            max: props.channelData.provider === ProviderType.SPRYNG ? 11 : 16,
            regex: /^[0-9a-zA-Z\s]*$/,
        };

        if (props.channelData.provider === ProviderType.SPRYNG) {
            isFetchingCredits.value = true;
            const auth = JSON.parse(props.channelData.auth);

            axios
                .get("https://rest.spryngsms.com/v1/balance", { headers: { Authorization: `Bearer ${auth.bearer}` } }) //
                .then((result) => (credits.value = result.data.amount))
                .finally(() => (isFetchingCredits.value = false));
        }

        return {
            getSettingByName,
            smsSenderRules,
            isFetchingCredits,
            credits,
            ProviderType,
        };
    },
};
</script>
